<template>
  <v-container fluid class="pa-4">
    <!-- Encabezado estilo V7 -->
    <v-card class="mb-4">
      <v-toolbar class="primary white--text">
        <v-icon color="white" left>mdi-cash-register</v-icon>
        ASIGNACION DE COBRANZA POR SEDE V8
        <v-spacer></v-spacer>
        <v-btn small outlined dark @click="$router.back()">
          <v-icon left small>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-toolbar>
    </v-card>
      
    <!-- Filtros -->
    <v-card class="pa-4 mb-4" elevation="2">
        <v-row dense align="center">
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filtros.fecha_inicio_mes"
              label="Fecha Inicio Mes"
              type="date"
              outlined
              dense
              prepend-icon="mdi-calendar-start"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filtros.fecha_consulta"
              label="Fecha Consulta"
              type="date"
              outlined
              dense
              prepend-icon="mdi-calendar-check"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-alert dense outlined color="primary" class="mb-0">
              <div class="caption font-weight-medium">
                <v-icon small color="primary">mdi-office-building</v-icon>
                Sede seleccionada
              </div>
              <div class="caption">{{ sedeSeleccionadaTexto }}</div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="3" class="d-flex align-center">
            <v-btn color="primary" @click="fetchData" :loading="loading" large block>
              <v-icon left>mdi-calculator</v-icon> Calcular
            </v-btn>
          </v-col>
        </v-row>
    </v-card>

    <!-- Filtros Avanzados -->
    <v-card class="mb-4" elevation="2" v-if="records.length > 0">
      <v-card-title class="primary white--text py-3 text-subtitle-1">
        <v-icon color="white" left>mdi-filter-variant</v-icon>
        Filtros Avanzados
        <v-spacer></v-spacer>
        <v-chip color="white" outlined small class="font-weight-bold">
          {{ datosFiltrados.length }} de {{ records.length }} registros
        </v-chip>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row dense>
          <v-col cols="12" md="4">
            <v-text-field v-model="busqueda" label="Buscar estudiante, documento, correo o programa" prepend-inner-icon="mdi-magnify" outlined dense clearable hide-details></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filtroAsignacion" :items="opcionesAsignacion" label="Tipo Asignación" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filtroEstado" :items="opcionesEstado" label="Estado" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filtroTipoPlan" :items="opcionesTipoPlan" label="Tipo Plan" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filtroConceptos" :items="opcionesConcepto" item-text="text" item-value="value"
              label="Conceptos" multiple chips clearable outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="error" outlined block @click="limpiarFiltros">
              <v-icon left>mdi-filter-remove</v-icon>
              Limpiar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Tarjetas de Resumen -->
    <v-row v-if="records.length > 0" class="mb-4" dense>
      <v-col cols="12" sm="6" md="3" v-for="card in cardsResumen" :key="card.key">
        <v-card :color="card.color" dark elevation="2" style="min-height: 120px;">
          <v-card-text class="text-center">
            <v-icon color="white" class="mb-2">{{ card.icon }}</v-icon>
            <div class="text-h5 font-weight-bold">{{ formatMonto(card.value) }}</div>
            <div class="text-caption text-uppercase">{{ card.title }}</div>
            <template v-if="card.cobranza !== undefined || card.marketing !== undefined">
              <v-divider dark class="my-2"></v-divider>
              <v-row no-gutters justify="space-around" align="center">
                <v-col cols="6" class="px-1">
                  <div class="caption font-weight-bold">{{ formatMonto(card.cobranza || 0) }}</div>
                  <v-chip color="red lighten-1" x-small text-color="white" class="mt-1">
                    <v-icon left x-small>mdi-cash</v-icon>Cobranza
                  </v-chip>
                </v-col>
                <v-col cols="6" class="px-1">
                  <div class="caption font-weight-bold">{{ formatMonto(card.marketing || 0) }}</div>
                  <v-chip color="green lighten-1" x-small text-color="white" class="mt-1">
                    <v-icon left x-small>mdi-account-group</v-icon>Marketing
                  </v-chip>
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Gráficos -->
    <v-card v-if="records.length > 0" class="mb-4" elevation="2">
      <v-card-title class="white--text py-3" style="background-color:#1976d2">
        <v-icon color="white" left>mdi-chart-box</v-icon>
        Gráficos de avance
        <v-spacer></v-spacer>
        <v-btn icon dark @click="mostrarGraficos = !mostrarGraficos">
          <v-icon>{{ mostrarGraficos ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-expand-transition>
        <div v-show="mostrarGraficos">
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="4">
                <div class="text-center subtitle-2 mb-2">Avance de cobranza</div>
                <div class="chart-wrapper">
                  <canvas ref="chartProgreso"></canvas>
                  <div class="chart-center-label">
                    <div class="text-h4 font-weight-bold primary--text">{{ porcentajeCobranza }}%</div>
                    <div class="caption grey--text">cobrado</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-center subtitle-2 mb-2">Composición Cobranza vs Marketing</div>
                <div class="chart-wrapper">
                  <canvas ref="chartComposicion"></canvas>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-center subtitle-2 mb-2">Estado de asignaciones</div>
                <div class="chart-wrapper">
                  <canvas ref="chartEstado"></canvas>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>

    <v-card elevation="2">
      <!-- Tabs para separar vistas estilo V7 -->
      <v-tabs v-model="tab" background-color="primary" dark grow>
        <v-tab>
          <v-icon left>mdi-table</v-icon>
          Registros Generales
        </v-tab>
        <v-tab>
          <v-icon left>mdi-school</v-icon>
          Resumen por Programa
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-tie</v-icon>
          Cobranza por Encargado
        </v-tab>
        <v-tab>
          <v-icon left>mdi-calendar-multiple-check</v-icon>
          Por Plan de Pago
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- Tab 1: Todos los Registros -->
        <v-tab-item>
          <v-card flat>
            <v-card-title class="grey lighten-4 py-2 text-subtitle-1">
              <v-icon left color="primary">mdi-format-list-bulleted</v-icon>
              Detalle de Asignaciones V8
              <v-spacer></v-spacer>
              <!-- El buscador propio de la tabla se elimina a favor del filtro general -->
            </v-card-title>

            <v-card-text>
              <v-data-table
                :headers="headersGenerales"
                :items="datosFiltrados"
                :loading="loading"
                class="elevation-1"
                :items-per-page="10"
                dense
              >
                <!-- Formato Estudiante -->
                <template v-slot:item.estudiante="{ item }">
                  <div>
                    <div class="font-weight-bold">{{ item.est_nombres }} {{ item.est_apellidos }}</div>
                    <div class="caption grey--text"><v-icon x-small>mdi-card-account-details</v-icon> {{ item.est_num_doc }}</div>
                    <div class="caption"><v-icon x-small>mdi-email</v-icon> {{ item.est_correo }}</div>
                  </div>
                </template>
                <!-- Formato Programa -->
                <template v-slot:item.programa="{ item }">
                  <div>
                    <div class="font-weight-medium">{{ item.prog_codigo || 'S/C' }}</div>
                    <div class="caption">{{ item.prog_nombre_compuesto }}</div>
                  </div>
                </template>
                <!-- Formato Chips de Estado y Tipo -->
                <template v-slot:item.asig_estado="{ item }">
                  <v-chip :color="getColorEstado(item.asig_estado)" small dark>
                    {{ item.asig_estado }}
                  </v-chip>
                </template>
                <template v-slot:item.tipo_registro="{ item }">
                  <v-chip color="blue-grey" small dark outlined>
                    {{ item.tipo_registro }}
                  </v-chip>
                </template>
                <!-- Montos -->
                <template v-slot:item.pago_monto="{ item }">
                  <span class="success--text font-weight-bold">{{ formatMonto(item.pago_monto) }}</span>
                </template>
                <template v-slot:item.plan_pago_monto="{ item }">
                  <strong>{{ formatMonto(item.plan_pago_monto) }}</strong>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Tab 2: Resumen por Programa -->
        <v-tab-item>
          <v-card flat>
            <v-card-title class="grey lighten-4 py-2 text-subtitle-1">
              <v-icon left color="primary">mdi-school</v-icon>
              Rendimiento por Programas
              <v-spacer></v-spacer>
            </v-card-title>

            <v-card-text>
              <v-data-table
                :headers="headersProgramas"
                :items="resumenPorPrograma"
                :loading="loading"
                class="elevation-1"
                :items-per-page="10"
                fixed-header
                height="600"
                dense
              >
                <template v-slot:item.codigo="{ item }">
                  <div class="d-flex align-center">
                    <span class="font-weight-medium">{{ item.codigo }}</span>
                    <v-btn icon x-small color="primary" class="ml-1" title="Filtrar por este código"
                      @click="busqueda = item.codigo">
                      <v-icon x-small>mdi-magnify</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-slot:item.asig_tipos="{ item }">
                  <div class="d-flex flex-wrap" style="gap: 2px; max-width: 160px;">
                    <v-chip v-for="t in item.asig_tipos" :key="t" :color="colorAsigTipo(t)" x-small dark>
                      {{ t }}
                    </v-chip>
                  </div>
                </template>
                <template v-slot:item.asignacion="{ item }">
                  <strong>{{ formatMonto(item.asignacion) }}</strong>
                </template>
                <template v-slot:item.monto_revertido="{ item }">
                  <span :class="item.monto_revertido > 0 ? 'orange--text font-weight-bold' : ''">
                    {{ formatMonto(item.monto_revertido) }}
                  </span>
                </template>
                <template v-slot:item.monto_descuento="{ item }">
                  <span :class="item.monto_descuento > 0 ? 'deep-orange--text font-weight-bold' : ''">
                    {{ formatMonto(item.monto_descuento) }}
                  </span>
                </template>
                <template v-slot:item.cambiado="{ item }">
                  <span :class="item.cambiado > 0 ? 'purple--text font-weight-bold' : ''">
                    {{ formatMonto(item.cambiado) }}
                  </span>
                </template>
                <template v-slot:item.monto_pagado="{ item }">
                  <span class="success--text font-weight-bold">{{ formatMonto(item.monto_pagado) }}</span>
                </template>
                <template v-slot:item.saldo="{ item }">
                  <strong :class="item.saldo > 0 ? 'error--text' : 'success--text'">
                    {{ formatMonto(item.saldo) }}
                  </strong>
                </template>
                <template v-slot:item.monto_adelantado="{ item }">
                  <span :class="item.monto_adelantado > 0 ? 'light-green--text text--darken-2 font-weight-bold' : ''">
                    {{ formatMonto(item.monto_adelantado) }}
                  </span>
                </template>
                <template v-slot:item.porcentaje="{ item }">
                  <v-chip :color="getColorPorcentaje(item.porcentaje)" dark small>{{ item.porcentaje }}%</v-chip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Tab 3: Resumen por Encargado -->
        <v-tab-item>
          <v-card flat>
            <v-card-title class="grey lighten-4 py-2 text-subtitle-1">
              <v-icon left color="primary">mdi-chart-bar</v-icon>
              Rendimiento de Cobranza
              <v-spacer></v-spacer>
              <v-btn color="success" @click="exportarExcel" :disabled="!resumenPorEncargado.length">
                <v-icon left>mdi-file-excel</v-icon> Exportar Excel
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-data-table
                :headers="headersEncargados"
                :items="resumenPorEncargado"
                :loading="loading"
                class="elevation-1"
                hide-default-footer
                :items-per-page="-1"
                fixed-header
                height="600"
                dense
              >
                <template v-slot:item.encargado="{ item }">
                  <v-avatar size="32" color="deep-purple" class="mr-2 mb-1 mt-1">
                    <span class="white--text text-caption">{{ getIniciales(item.encargado) }}</span>
                  </v-avatar>
                  <span class="font-weight-medium">{{ item.encargado }}</span>
                </template>
                <template v-slot:item.asig_tipos="{ item }">
                  <div class="d-flex flex-wrap" style="gap: 2px; max-width: 160px;">
                    <v-chip v-for="t in item.asig_tipos" :key="t" :color="colorAsigTipo(t)" x-small dark>
                      {{ t }}
                    </v-chip>
                  </div>
                </template>
                <template v-slot:item.asignacion="{ item }">
                  <strong>{{ formatMonto(item.asignacion) }}</strong>
                </template>
                <template v-slot:item.monto_revertido="{ item }">
                  <span :class="item.monto_revertido > 0 ? 'orange--text font-weight-bold' : ''">
                    {{ formatMonto(item.monto_revertido) }}
                  </span>
                </template>
                <template v-slot:item.monto_descuento="{ item }">
                  <span :class="item.monto_descuento > 0 ? 'deep-orange--text font-weight-bold' : ''">
                    {{ formatMonto(item.monto_descuento) }}
                  </span>
                </template>
                <template v-slot:item.cambiado="{ item }">
                  <span :class="item.cambiado > 0 ? 'purple--text font-weight-bold' : ''">
                    {{ formatMonto(item.cambiado) }}
                  </span>
                </template>
                <template v-slot:item.monto_pagado="{ item }">
                  <span class="success--text font-weight-bold">{{ formatMonto(item.monto_pagado) }}</span>
                </template>
                <template v-slot:item.saldo="{ item }">
                  <strong :class="item.saldo > 0 ? 'error--text' : 'success--text'">
                    {{ formatMonto(item.saldo) }}
                  </strong>
                </template>
                <template v-slot:item.monto_adelantado="{ item }">
                  <span :class="item.monto_adelantado > 0 ? 'light-green--text text--darken-2 font-weight-bold' : ''">
                    {{ formatMonto(item.monto_adelantado) }}
                  </span>
                </template>
                <template v-slot:item.porcentaje="{ item }">
                  <v-progress-linear :value="item.porcentaje" :color="getColorPorcentaje(item.porcentaje)" height="18" rounded dark>
                    <strong>{{ item.porcentaje }}%</strong>
                  </v-progress-linear>
                </template>
                <template v-slot:item.acciones="{ item }">
                  <v-btn color="info" small @click="verDetalles(item)">
                    Ver {{ item.cantidad_registros }} Registros
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Tab 4: Por Plan de Pago -->
        <v-tab-item>
          <v-card flat>
            <v-card-title class="grey lighten-4 py-2 text-subtitle-1">
              <v-icon left color="primary">mdi-calendar-multiple-check</v-icon>
              Resumen por Plan de Pago
              <v-spacer></v-spacer>
              <v-chip color="primary" outlined small>{{ resumenPorPlanPago.length }} planes</v-chip>
            </v-card-title>

            <v-card-text>
              <v-data-table
                :headers="headersPlanPago"
                :items="resumenPorPlanPago"
                :loading="loading"
                class="elevation-1"
                :items-per-page="10"
                fixed-header
                height="600"
                dense
              >
                <template v-slot:item.estudiante="{ item }">
                  <div>
                    <div class="font-weight-bold">{{ item.nombre_estudiante }}</div>
                    <div class="caption grey--text">
                      <v-icon x-small>mdi-card-account-details</v-icon> {{ item.est_num_doc }}
                    </div>
                    <div class="caption" v-if="item.est_telefono">
                      <v-icon x-small>mdi-phone</v-icon> {{ item.est_telefono }}
                    </div>
                  </div>
                </template>
                <template v-slot:item.programa="{ item }">
                  <div>
                    <div class="font-weight-medium">{{ item.prog_codigo || 'S/C' }}</div>
                    <div class="caption">{{ item.prog_nombre_compuesto }}</div>
                    <div class="caption grey--text" v-if="item.prog_area">{{ item.prog_area }}</div>
                  </div>
                </template>
                <template v-slot:item.fechas_prog="{ item }">
                  <div class="caption">
                    <div><v-icon x-small>mdi-calendar-start</v-icon> {{ formatFecha(item.prog_fecha_inicio) }}</div>
                    <div><v-icon x-small>mdi-calendar-end</v-icon> {{ formatFecha(item.prog_fecha_fin) }}</div>
                  </div>
                </template>
                <template v-slot:item.plan_pago_fecha_limite_pago="{ item }">
                  <span class="caption">{{ formatFecha(item.plan_pago_fecha_limite_pago) }}</span>
                </template>
                <template v-slot:item.plan_pago_fecha_actual="{ item }">
                  <span class="caption">{{ formatFecha(item.plan_pago_fecha_actual) }}</span>
                </template>
                <template v-slot:item.plan_modificado="{ item }">
                  <v-chip :color="item.plan_modificado == 1 ? 'orange' : 'grey'" x-small dark>
                    {{ item.plan_modificado == 1 ? 'Sí' : 'No' }}
                  </v-chip>
                </template>
                <template v-slot:item.asig_estados="{ item }">
                  <div class="d-flex flex-wrap" style="gap: 2px; max-width: 160px;">
                    <v-chip
                      v-for="estado in item.asig_estados"
                      :key="estado"
                      :color="getColorEstado(estado)"
                      x-small
                      dark
                    >
                      {{ estado }}
                    </v-chip>
                  </div>
                </template>
                <template v-slot:item.asig_tipos="{ item }">
                  <div class="d-flex flex-wrap" style="gap: 2px; max-width: 160px;">
                    <v-chip v-for="t in item.asig_tipos" :key="t" :color="colorAsigTipo(t)" x-small dark>
                      {{ t }}
                    </v-chip>
                  </div>
                </template>
                <template v-slot:item.tipos_registro="{ item }">
                  <div class="d-flex flex-wrap" style="gap: 2px; max-width: 180px;">
                    <v-chip
                      v-for="tipo in item.tipos_registro"
                      :key="tipo"
                      :color="colorTipoRegistro(tipo)"
                      x-small
                      dark
                    >
                      {{ tipo }}
                    </v-chip>
                  </div>
                </template>
                <template v-slot:item.asignacion="{ item }">
                  <strong>{{ formatMonto(item.asignacion) }}</strong>
                </template>
                <template v-slot:item.monto_revertido="{ item }">
                  <span :class="item.monto_revertido > 0 ? 'orange--text font-weight-bold' : ''">
                    {{ formatMonto(item.monto_revertido) }}
                  </span>
                </template>
                <template v-slot:item.monto_descuento="{ item }">
                  <span :class="item.monto_descuento > 0 ? 'deep-orange--text font-weight-bold' : ''">
                    {{ formatMonto(item.monto_descuento) }}
                  </span>
                </template>
                <template v-slot:item.cambiado="{ item }">
                  <span :class="item.cambiado > 0 ? 'purple--text font-weight-bold' : ''">
                    {{ formatMonto(item.cambiado) }}
                  </span>
                </template>
                <template v-slot:item.monto_pagado="{ item }">
                  <span class="success--text font-weight-bold">{{ formatMonto(item.monto_pagado) }}</span>
                </template>
                <template v-slot:item.monto_adelantado="{ item }">
                  <span :class="item.monto_adelantado > 0 ? 'light-green--text text--darken-2 font-weight-bold' : ''">
                    {{ formatMonto(item.monto_adelantado) }}
                  </span>
                </template>
                <template v-slot:item.saldo="{ item }">
                  <strong :class="item.saldo > 0 ? 'error--text' : 'success--text'">
                    {{ formatMonto(item.saldo) }}
                  </strong>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Dialog para ver detalles del encargado -->
    <v-dialog v-model="dialogDetalles" max-width="1200px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Registros de: {{ encargadoSeleccionado }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDetalles = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-data-table
            :headers="headersGenerales"
            :items="registrosSeleccionados"
            class="elevation-1"
          >
            <template v-slot:item.pago_monto="{ item }">
              {{ item.pago_monto || '0.00' }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import xaxios from '@/xaxios';
import Chart from 'chart.js';

const toISODate = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);

export default {
  name: 'AsignacionesSeedeeV8',
  data() {
    const hoy = new Date();
    const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    return {
      loading: false,
      tab: 0,
      busqueda: '',
      filtroEstado: 'todos',
      filtroAsignacion: 'todos',
      filtroTipoPlan: 'todos',
      filtroConceptos: [],
      filtros: {
        fecha_inicio_mes: toISODate(primerDiaMes),
        fecha_consulta: toISODate(hoy),
      },
      sedeId: '',
      sedeNombre: '',
      mostrarGraficos: true,
      chartInstances: { progreso: null, composicion: null, estado: null },
      records: [],
      dialogDetalles: false,
      encargadoSeleccionado: '',
      registrosSeleccionados: [],
      headersGenerales: [
        { text: 'Estudiante', value: 'estudiante', sortable: false },
        { text: 'Programa', value: 'programa', sortable: false },
        { text: 'Tipo Registro', value: 'tipo_registro' },
        { text: 'Estado Asig.', value: 'asig_estado' },
        { text: 'Cuota', value: 'plan_pago_cuota', align: 'center' },
        { text: 'Esperado (Bs)', value: 'plan_pago_monto', align: 'right' },
        { text: 'Pagado (Bs)', value: 'pago_monto', align: 'right' },
        { text: 'Encargado Cobranza', value: 'encargado_cobranza' },
      ],
      headersProgramas: [
        { text: 'Código', value: 'codigo' },
        { text: 'Programa', value: 'nombre_compuesto', width: '20%' },
        { text: 'Estudiantes', value: 'cantidad_estudiantes', align: 'center' },
        { text: 'Registros', value: 'cantidad_registros', align: 'center' },
        { text: 'Tipo Asig.', value: 'asig_tipos', sortable: false },
        { text: 'Asignación (Bs)', value: 'asignacion', align: 'right' },
        { text: 'Revertido (Bs)', value: 'monto_revertido', align: 'right' },
        { text: 'Descuento (Bs)', value: 'monto_descuento', align: 'right' },
        { text: 'Cambiado (Bs)', value: 'cambiado', align: 'right' },
        { text: 'Pagado (Bs)', value: 'monto_pagado', align: 'right' },
        { text: 'Saldo (Bs)', value: 'saldo', align: 'right' },
        { text: 'Adelantado (Bs)', value: 'monto_adelantado', align: 'right' },
        { text: '% Cobranza', value: 'porcentaje', align: 'center' },
      ],
      headersEncargados: [
        { text: 'Encargado de Cobranza', value: 'encargado' },
        { text: 'Registros', value: 'cantidad_registros', align: 'center' },
        { text: 'Tipo Asig.', value: 'asig_tipos', sortable: false },
        { text: 'Asignación (Bs)', value: 'asignacion', align: 'right' },
        { text: 'Revertido (Bs)', value: 'monto_revertido', align: 'right' },
        { text: 'Descuento (Bs)', value: 'monto_descuento', align: 'right' },
        { text: 'Cambiado (Bs)', value: 'cambiado', align: 'right' },
        { text: 'Pagado (Bs)', value: 'monto_pagado', align: 'right' },
        { text: 'Saldo (Bs)', value: 'saldo', align: 'right' },
        { text: 'Adelantado (Bs)', value: 'monto_adelantado', align: 'right' },
        { text: '% Cobranza', value: 'porcentaje', width: '200px' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ],
      headersPlanPago: [
        { text: 'Estudiante', value: 'estudiante', sortable: false },
        { text: 'Programa', value: 'programa', sortable: false },
        { text: 'Fechas Prog.', value: 'fechas_prog', sortable: false },
        { text: 'Fecha Límite', value: 'plan_pago_fecha_limite_pago', align: 'center' },
        { text: 'Fecha Actual', value: 'plan_pago_fecha_actual', align: 'center' },
        { text: 'Tipo Plan', value: 'ins_tipo_plan' },
        { text: 'Cuota', value: 'plan_pago_cuota', align: 'center' },
        { text: 'Modificado', value: 'plan_modificado', align: 'center' },
        { text: 'Estado Asig.', value: 'asig_estados', sortable: false },
        { text: 'Tipo Asig.', value: 'asig_tipos', sortable: false },
        { text: 'Tipos Registro', value: 'tipos_registro', sortable: false },
        { text: 'Asignación (Bs)', value: 'asignacion', align: 'right' },
        { text: 'Revertido (Bs)', value: 'monto_revertido', align: 'right' },
        { text: 'Descuento (Bs)', value: 'monto_descuento', align: 'right' },
        { text: 'Cambiado (Bs)', value: 'cambiado', align: 'right' },
        { text: 'Pagado (Bs)', value: 'monto_pagado', align: 'right' },
        { text: 'Saldo (Bs)', value: 'saldo', align: 'right' },
        { text: 'Adelantado (Bs)', value: 'monto_adelantado', align: 'right' },
      ],
    };
  },
  computed: {
    sedeSeleccionadaTexto() {
      const nombre = this.sedeNombre || 'Sin nombre';
      return `${nombre} (${this.sedeId || 'sin id'})`;
    },
    porcentajeCobranza() {
      const total = this.resumenGeneral.asignacion_mes;
      if (!total) return 0;
      const pct = (this.resumenGeneral.pagado / total) * 100;
      return Math.max(0, Math.min(100, Math.round(pct)));
    },
    estadisticasPorEstado() {
      const conteos = {};
      this.datosFiltrados.forEach(item => {
        const estado = item.asig_estado || 'Sin estado';
        conteos[estado] = (conteos[estado] || 0) + 1;
      });
      return conteos;
    },
    opcionesEstado() { return this.opcionesUnicas('asig_estado', 'Todos'); },
    opcionesAsignacion() { return this.opcionesUnicas('asig_tipo', 'Todas'); },
    opcionesTipoPlan() { return this.opcionesUnicas('ins_tipo_plan', 'Todos'); },
    opcionesConcepto() {
      const map = new Map();
      this.records.forEach(item => {
        const id = this.getConceptoId(item);
        const nombre = this.getConceptoNombre(item);
        if (id != null && nombre) map.set(id, nombre);
      });
      return Array.from(map, ([value, text]) => ({ value, text })).sort((a, b) => a.text.localeCompare(b.text));
    },
    
    datosFiltrados() {
      let datos = this.records;
      if (this.filtroAsignacion !== 'todos') {
        datos = datos.filter(item => item.asig_tipo === this.filtroAsignacion);
      }
      if (this.filtroEstado !== 'todos') {
        datos = datos.filter(item => item.asig_estado === this.filtroEstado);
      }
      if (this.filtroTipoPlan !== 'todos') {
        datos = datos.filter(item => item.ins_tipo_plan === this.filtroTipoPlan);
      }
      if (this.filtroConceptos.length > 0) {
        datos = datos.filter(item => this.filtroConceptos.includes(this.getConceptoId(item)));
      }
      if (this.busqueda) {
        const q = this.busqueda.toLowerCase();
        datos = datos.filter(item => [
          item.est_nombres,
          item.est_apellidos,
          item.est_num_doc,
          item.est_correo,
          item.prog_codigo,
          item.prog_nombre_compuesto,
        ].some(value => String(value || '').toLowerCase().includes(q)));
      }
      return datos;
    },
    resumenPorEncargado() {
      const agrupado = {};

      this.datosFiltrados.forEach((item) => {
        const encargado = item.encargado_cobranza || 'Sin Asignar';

        if (!agrupado[encargado]) {
          agrupado[encargado] = {
            encargado,
            cantidad_registros: 0,
            asig_tipos_set: new Set(),
            asignacion: 0,
            monto_revertido: 0,
            monto_descuento: 0,
            cambiado: 0,
            monto_pagado: 0,
            monto_adelantado: 0,
            registros: [],
          };
        }
        const g = agrupado[encargado];
        g.cantidad_registros += 1;
        g.registros.push(item);
        if (item.asig_tipo) g.asig_tipos_set.add(item.asig_tipo);

        const tipo = String(item.tipo_registro || '').trim().toLowerCase();

        if (tipo === 'nuevo') {
          g.asignacion += parseFloat(item.plan_pago_monto) || 0;
        } else if (tipo === 'dw') {
          g.asignacion += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          if (item.plan_modificado == 1) {
            g.cambiado += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          }
        } else if (tipo === 'descuento_revertido') {
          g.monto_revertido += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'descuento_aprobado') {
          g.monto_descuento += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'pagado') {
          const monto = parseFloat(item.pago_monto) || 0;
          if (item.asig_estado === 'adelantado') {
            g.monto_adelantado += monto;
          } else {
            g.monto_pagado += monto;
          }
        }
      });

      return Object.values(agrupado).map(g => {
        const saldo = g.asignacion + g.monto_revertido - g.monto_descuento - g.monto_pagado - g.cambiado;
        const base = g.asignacion + g.monto_revertido - g.monto_descuento - g.cambiado;
        return {
          ...g,
          asig_tipos: Array.from(g.asig_tipos_set).sort(),
          saldo,
          porcentaje: base > 0 ? ((g.monto_pagado / base) * 100).toFixed(2) : '0.00',
        };
      }).sort((a, b) => b.asignacion - a.asignacion);
    },
    resumenPorPlanPago() {
      const agrupado = {};
      this.datosFiltrados.forEach(item => {
        const key = item.plan_pagos_id != null ? item.plan_pagos_id : `sin_id_${item.id || Math.random()}`;
        if (!agrupado[key]) {
          agrupado[key] = {
            plan_pagos_id: item.plan_pagos_id,
            nombre_estudiante: `${item.est_nombres || ''} ${item.est_apellidos || ''}`.trim(),
            est_num_doc: item.est_num_doc || '',
            est_telefono: item.est_telefono || '',
            prog_nombre_compuesto: item.prog_nombre_compuesto || '',
            prog_codigo: item.prog_codigo || '',
            prog_area: item.prog_area || '',
            prog_fecha_inicio: item.prog_fecha_inicio || '',
            prog_fecha_fin: item.prog_fecha_fin || '',
            ins_tipo_plan: item.ins_tipo_plan || '',
            plan_pago_cuota: item.plan_pago_cuota != null ? item.plan_pago_cuota : '',
            plan_pago_fecha_limite_pago: item.plan_pago_fecha_limite_pago || '',
            plan_pago_fecha_actual: item.plan_pago_fecha_actual || '',
            plan_modificado: item.plan_modificado || 0,
            tipos_registro_set: new Set(),
            asig_estados_set: new Set(),
            asig_tipos_set: new Set(),
            asignacion: 0,
            monto_revertido: 0,
            monto_descuento: 0,
            cambiado: 0,
            monto_pagado: 0,
            monto_adelantado: 0,
          };
        }
        const g = agrupado[key];
        const tipo = String(item.tipo_registro || '').trim().toLowerCase();
        if (tipo) g.tipos_registro_set.add(tipo);
        if (item.asig_estado) g.asig_estados_set.add(item.asig_estado);
        if (item.asig_tipo) g.asig_tipos_set.add(item.asig_tipo);

        if (tipo === 'nuevo') {
          g.asignacion += parseFloat(item.plan_pago_monto) || 0;
        } else if (tipo === 'dw') {
          g.asignacion += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          if (item.plan_modificado == 1) {
            g.cambiado += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          }
        } else if (tipo === 'descuento_revertido') {
          g.monto_revertido += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'descuento_aprobado') {
          g.monto_descuento += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'pagado') {
          const monto = parseFloat(item.pago_monto) || 0;
          if (item.asig_estado === 'adelantado') {
            g.monto_adelantado += monto;
          } else {
            g.monto_pagado += monto;
          }
        }

        if (item.plan_modificado == 1) g.plan_modificado = 1;
      });
      return Object.values(agrupado).map(g => ({
        ...g,
        tipos_registro: Array.from(g.tipos_registro_set).sort(),
        asig_estados: Array.from(g.asig_estados_set).sort(),
        asig_tipos: Array.from(g.asig_tipos_set).sort(),
        saldo: g.asignacion + g.monto_revertido - g.monto_descuento - g.monto_pagado - g.cambiado,
      })).sort((a, b) => b.asignacion - a.asignacion);
    },
    resumenPorPrograma() {
      const agrupado = {};

      this.datosFiltrados.forEach(item => {
        const key = item.prog_codigo || 'S/C';
        if (!agrupado[key]) {
          agrupado[key] = {
            codigo: item.prog_codigo || 'S/C',
            nombre_compuesto: item.prog_nombre_compuesto || 'Sin programa',
            cantidad_registros: 0,
            estudiantes: new Set(),
            asig_tipos_set: new Set(),
            asignacion: 0,
            monto_revertido: 0,
            monto_descuento: 0,
            cambiado: 0,
            monto_pagado: 0,
            monto_adelantado: 0,
          };
        }
        const g = agrupado[key];
        g.cantidad_registros++;
        if (item.est_num_doc) g.estudiantes.add(item.est_num_doc);
        if (item.asig_tipo) g.asig_tipos_set.add(item.asig_tipo);

        const tipo = String(item.tipo_registro || '').trim().toLowerCase();

        if (tipo === 'nuevo') {
          g.asignacion += parseFloat(item.plan_pago_monto) || 0;
        } else if (tipo === 'dw') {
          g.asignacion += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          if (item.plan_modificado == 1) {
            g.cambiado += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          }
        } else if (tipo === 'descuento_revertido') {
          g.monto_revertido += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'descuento_aprobado') {
          g.monto_descuento += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'pagado') {
          const monto = parseFloat(item.pago_monto) || 0;
          if (item.asig_estado === 'adelantado') {
            g.monto_adelantado += monto;
          } else {
            g.monto_pagado += monto;
          }
        }
      });

      return Object.values(agrupado).map(g => {
        const saldo = g.asignacion + g.monto_revertido - g.monto_descuento - g.monto_pagado - g.cambiado;
        const base = g.asignacion + g.monto_revertido - g.monto_descuento - g.cambiado;
        return {
          ...g,
          cantidad_estudiantes: g.estudiantes.size,
          asig_tipos: Array.from(g.asig_tipos_set).sort(),
          saldo,
          porcentaje: base > 0 ? ((g.monto_pagado / base) * 100).toFixed(2) : '0.00',
        };
      }).sort((a, b) => b.asignacion - a.asignacion);
    },
    resumenGeneral() {
      const acc = {
        inicial:0,inicial_cobranza:0,inicial_marketing:0,
        descuento_revertido: 0, descuento_revertido_cobranza: 0, descuento_revertido_marketing: 0,
        descuento_aprobado: 0, descuento_aprobado_cobranza: 0, descuento_aprobado_marketing: 0,
        cambio_plan: 0, cambio_plan_cobranza: 0, cambio_plan_marketing: 0,
        nuevo_plan: 0, nuevo_plan_cobranza: 0, nuevo_plan_marketing: 0,        
        pagado: 0, pagado_cobranza: 0, pagado_marketing: 0,
        pagado_adelantado: 0, pagado_adelantado_cobranza: 0, pagado_adelantado_marketing: 0,
        revertido: 0, revertido_cobranza: 0, revertido_marketing: 0,
        esperado: 0, esperado_cobranza: 0, esperado_marketing: 0,
      };

      this.datosFiltrados.forEach(item => {
        
        const tipoRegistro = String(item.tipo_registro || '').trim().toLowerCase();

        
        if (tipoRegistro === 'dw') {
          const montoDw = parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          const tipoDw = String(item.asig_tipo || '').toLowerCase();
          if (tipoDw.includes('cobranza') || tipoDw.includes('cartera')) {            
            acc.inicial_cobranza += montoDw;
          } else if (tipoDw.includes('marketing') || tipoDw.includes('nuevos') || tipoDw.includes('inscritos')) {
            
            acc.inicial_marketing += montoDw;
          } 
          acc.inicial += montoDw;           
        }

        if (tipoRegistro === 'dw' && item.plan_modificado==1) {
          const montoDwCambio = parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          const tipoDwCambio = String(item.asig_tipo || '').toLowerCase();
          if (tipoDwCambio.includes('cobranza') || tipoDwCambio.includes('cartera')) {
            
            acc.cambio_plan_cobranza += montoDwCambio;
          } else if (tipoDwCambio.includes('marketing') || tipoDwCambio.includes('nuevos') || tipoDwCambio.includes('inscritos')) {
              
            acc.cambio_plan_marketing += montoDwCambio;
          } 
          acc.cambio_plan += montoDwCambio;           
        }

        if (tipoRegistro === 'descuento_revertido') {

          const montoRevertido = parseFloat(item.descuento_monto_revertido) || 0;
          const tipoRevertido = String(item.asig_tipo || '').toLowerCase();
          if (tipoRevertido.includes('cobranza') || tipoRevertido.includes('cartera')) {
            acc.descuento_revertido_cobranza += montoRevertido;
          } else if (tipoRevertido.includes('marketing') || tipoRevertido.includes('nuevos') || tipoRevertido.includes('inscritos')) {
            acc.descuento_revertido_marketing += montoRevertido;
          } 
          acc.descuento_revertido += montoRevertido;           
        }

        if (tipoRegistro === 'descuento_aprobado') {
          window.console.log('Procesando descuento_aprobado:', item);

          const montoAprobado = parseFloat(item.descuento_monto_revertido) || 0;
          const tipoAprobado = String(item.asig_tipo || '').toLowerCase();
          if (tipoAprobado.includes('cobranza') || tipoAprobado.includes('cartera')) {
            acc.descuento_aprobado_cobranza += montoAprobado;
          } else if (tipoAprobado.includes('marketing') || tipoAprobado.includes('nuevos') || tipoAprobado.includes('inscritos')) {
            acc.descuento_aprobado_marketing += montoAprobado;
          } 
          acc.descuento_aprobado += montoAprobado;           
        }


        if (tipoRegistro === 'nuevo') {
          window.console.log('Procesando nuevo:', item);

          const montoNuevo = parseFloat(item.plan_pago_monto) || 0;
          const tipoNuevo = String(item.asig_tipo || '').toLowerCase();
          if (tipoNuevo.includes('cobranza') || tipoNuevo.includes('cartera')) {
            acc.nuevo_plan_cobranza += montoNuevo;
          } else if (tipoNuevo.includes('marketing') || tipoNuevo.includes('nuevos') || tipoNuevo.includes('inscritos')) {
            acc.nuevo_plan_marketing += montoNuevo;
          } 
          acc.nuevo_plan += montoNuevo;           
        }


         if (tipoRegistro === 'pagado' && item.asig_estado!='adelantado') {
          window.console.log('Procesando pagado:', item);          
          const montoPagado = parseFloat(item.pago_monto) || 0;
          const tipoPagado = String(item.asig_tipo || '').toLowerCase();
          if (tipoPagado.includes('cobranza') || tipoPagado.includes('cartera')) {
            acc.pagado_cobranza += montoPagado;
          } else if (tipoPagado.includes('marketing') || tipoPagado.includes('nuevos') || tipoPagado.includes('inscritos')) {
            acc.pagado_marketing += montoPagado;
          } 
          acc.pagado += montoPagado;           
        }
        if (tipoRegistro === 'pagado' && item.asig_estado==='adelantado') {
          window.console.log('Procesando pagado_adelantado:', item);          
          const montoPagadoAdelantado = parseFloat(item.pago_monto) || 0;
          const tipoPagadoAdelantado = String(item.asig_tipo || '').toLowerCase();
          if (tipoPagadoAdelantado.includes('cobranza') || tipoPagadoAdelantado.includes('cartera')) {
            acc.pagado_adelantado_cobranza += montoPagadoAdelantado;
          } else if (tipoPagadoAdelantado.includes('marketing') || tipoPagadoAdelantado.includes('nuevos') || tipoPagadoAdelantado.includes('inscritos')) {
            acc.pagado_adelantado_marketing += montoPagadoAdelantado;
          } 
          acc.pagado_adelantado += montoPagadoAdelantado;           
        }


        
        

        // const inicial = parseFloat(item.plan_pago_monto_inicial) || 0;
        // const tipoInicial = String(item.asig_tipo || '').toLowerCase();
        // if (tipoInicial.includes('cobranza') || tipoInicial.includes('cartera')) {
        //   acc.inicial_cobranza += inicial;
        // } else if (tipoInicial.includes('marketing') || tipoInicial.includes('nuevos') || tipoInicial.includes('inscritos')) {
        //   acc.inicial_marketing += inicial;
        // } else {
        //   acc.inicial += inicial;
        // }



        // const esperado = parseFloat(item.plan_pago_monto) || 0;
        // const pagado = parseFloat(item.pago_monto) || 0;
        // const revertido = parseFloat(item.descuento_monto_revertido) || 0;

        // const tipo = String(item.asig_tipo || '').toLowerCase();
        // const esCobranza = tipo.includes('cobranza') || tipo.includes('cartera');
        // const esMarketing = tipo.includes('marketing') || tipo.includes('nuevos') || tipo.includes('inscritos');

        // acc.esperado += esperado;
        // acc.pagado += pagado;
        // acc.revertido += revertido;

        // if (esCobranza) {
        //   acc.esperado_cobranza += esperado;
        //   acc.pagado_cobranza += pagado;
        //   acc.revertido_cobranza += revertido;
        // } else if (esMarketing) {
        //   acc.esperado_marketing += esperado;
        //   acc.pagado_marketing += pagado;
        //   acc.revertido_marketing += revertido;
        // }
      });

      return {
        ...acc,
        asignacion_mes: acc.inicial + acc.nuevo_plan + acc.descuento_revertido - acc.cambio_plan - acc.descuento_aprobado,
        asignacion_mes_cobranza: acc.inicial_cobranza + acc.nuevo_plan_cobranza + acc.descuento_revertido_cobranza - acc.cambio_plan_cobranza - acc.descuento_aprobado_cobranza,
        asignacion_mes_marketing: acc.inicial_marketing + acc.nuevo_plan_marketing + acc.descuento_revertido_marketing - acc.cambio_plan_marketing - acc.descuento_aprobado_marketing,
        saldo: acc.inicial + acc.nuevo_plan + acc.descuento_revertido - acc.cambio_plan - acc.descuento_aprobado - acc.pagado,
        saldo_cobranza: acc.inicial_cobranza + acc.nuevo_plan_cobranza + acc.descuento_revertido_cobranza - acc.cambio_plan_cobranza - acc.descuento_aprobado_cobranza - acc.pagado_cobranza,
        saldo_marketing: acc.inicial_marketing + acc.nuevo_plan_marketing + acc.descuento_revertido_marketing - acc.cambio_plan_marketing - acc.descuento_aprobado_marketing - acc.pagado_marketing,
      };
    },
    cardsResumen() {
      const r = this.resumenGeneral;
      window.console.log('Resumen General:', r);
      const mk = (key, title, color, icon, clampSaldo = false) => ({
        key, title, color, icon,
        value: clampSaldo ? Math.max(r[key], 0) : r[key],
        cobranza: r[`${key}_cobranza`],
        marketing: r[`${key}_marketing`],
      });
      return [
        mk('inicial', 'Total Inicial', 'blue darken-2', 'mdi-cash-multiple'),
        mk('descuento_revertido', 'Total Descuentos/Revertidos', 'orange darken-2', 'mdi-undo-variant'),
        mk('descuento_aprobado', 'Total Descuentos Aprobados', 'deep-orange darken-2', 'mdi-thumb-down'),
        mk('cambio_plan', 'Total Cambios de Fechas', 'teal darken-2', 'mdi-swap-horizontal'),
        mk('nuevo_plan', 'Total Nuevos Planes', 'cyan darken-2', 'mdi-file-plus'),                        
        mk('asignacion_mes', 'Total Asignación Mes', 'indigo darken-2', 'mdi-calendar-plus'),
        mk('pagado', 'Total Pagado Mes', 'green darken-2', 'mdi-cash-check'),
        mk('saldo', 'Saldo a Cobrar', 'red darken-2', 'mdi-cash-clock', true),        
        mk('pagado_adelantado', 'Total Pagado Adelantado', 'light-green darken-2', 'mdi-cash-clock'),
        // mk('esperado', 'Total Esperado', 'cyan darken-3', 'mdi-clipboard-text'),
        // mk('revertido', 'Descuentos / Revertidos', 'orange darken-2', 'mdi-undo'),
        // mk('saldo', 'Saldo a Cobrar', 'red darken-2', 'mdi-cash-clock', true),
      ];
    }
  },
  methods: {
    setSedePorDefecto() {
      const querySede = this.$route.query.sede || this.$route.query.idsede;
      const queryNombre = this.$route.query.name || this.$route.query.sede_nombre;
      const storeSede = this.$store.state.CARGO && this.$store.state.CARGO.sede ? this.$store.state.CARGO.sede : null;
      if (querySede) {
        this.sedeId = querySede;
        this.sedeNombre = queryNombre || this.sedeNombre || 'Sede por URL';
        return;
      }
      this.sedeId = storeSede && storeSede.id ? storeSede.id : 1;
      this.sedeNombre = storeSede && storeSede.nombre ? storeSede.nombre : 'Sede actual';
    },
    async fetchData() {
      this.loading = true;
      try {
        const url = `${process.env.VUE_APP_API_REST}/api/v8/esam/asignacion/programas`;
        const response = await xaxios.get(url, {
          params: {
            fecha_inicio_mes: this.filtros.fecha_inicio_mes,
            fecha_consulta: this.filtros.fecha_consulta,
            sede: this.sedeId,
          },
        });

        this.records = response.data.data || [];
      } catch (error) {
        window.console.error('Error al obtener datos V8:', error);
        this.$root.$notify?.show('Error al obtener los registros', { color: 'red' });
      } finally {
        this.loading = false;
      }
    },
    opcionesUnicas(campo, textoTodos) {
      const opciones = [{ text: textoTodos, value: 'todos' }];
      const valores = new Set(this.records.map(item => item[campo]).filter(Boolean));
      Array.from(valores).sort().forEach(value => opciones.push({ text: value, value }));
      return opciones;
    },
    limpiarFiltros() {
      this.busqueda = '';
      this.filtroEstado = 'todos';
      this.filtroAsignacion = 'todos';
      this.filtroTipoPlan = 'todos';
      this.filtroConceptos = [];
    },
    getConceptoId(item) {
      return item.plan_pago_concepto || null;
    },
    getConceptoNombre(item) {
      return item.plan_pago_concepto || '';
    },
    verDetalles(item) {
      this.encargadoSeleccionado = item.encargado;
      this.registrosSeleccionados = item.registros;
      this.dialogDetalles = true;
    },
    getColorPorcentaje(porcentaje) {
      const val = parseFloat(porcentaje);
      if (val >= 80) return 'green';
      if (val >= 50) return 'orange';
      return 'red';
    },
    getColorEstado(estado) {
      if (!estado) return 'grey';
      const val = estado.toLowerCase();
      if (val === 'vigente') return 'green';
      if (val === 'retrasado') return 'red';
      if (val === 'por recuperar') return 'orange';
      return 'grey';
    },
    formatMonto(monto) {
      const val = parseFloat(monto || 0);
      return new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val);
    },
    formatFecha(fecha) {
      if (!fecha) return '-';
      const partes = String(fecha).split('T')[0].split('-');
      if (partes.length !== 3) return fecha;
      const [anio, mes, dia] = partes;
      return `${dia}/${mes}/${anio}`;
    },
    colorTipoRegistro(tipo) {
      const map = {
        dw: 'blue darken-2',
        nuevo: 'cyan darken-2',
        pagado: 'green darken-2',
        descuento_aprobado: 'deep-orange darken-2',
        descuento_revertido: 'orange darken-2',
      };
      return map[tipo] || 'blue-grey';
    },
    colorAsigTipo(tipo) {
      const t = String(tipo || '').toLowerCase();
      if (t.includes('cobranza') || t.includes('cartera')) return 'red darken-2';
      if (t.includes('marketing') || t.includes('nuevos') || t.includes('inscritos')) return 'green darken-2';
      return 'blue-grey';
    },
    formatTooltipMonto(value) {
      return new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    },
    destroyChart(key) {
      if (this.chartInstances[key]) {
        this.chartInstances[key].destroy();
        this.chartInstances[key] = null;
      }
    },
    destroyAllCharts() {
      Object.keys(this.chartInstances).forEach(k => this.destroyChart(k));
    },
    renderGraficos() {
      this.renderChartProgreso();
      this.renderChartComposicion();
      this.renderChartEstado();
    },
    renderChartProgreso() {
      const ref = this.$refs.chartProgreso;
      if (!ref) return;
      this.destroyChart('progreso');
      const r = this.resumenGeneral;
      const pagado = r.pagado;
      const saldo = Math.max(r.asignacion_mes - r.pagado, 0);
      const self = this;
      this.chartInstances.progreso = new Chart(ref.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: ['Pagado', 'Saldo'],
          datasets: [{ data: [pagado, saldo], backgroundColor: ['#43a047', '#e53935'], borderWidth: 0 }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 72,
          legend: { display: false },
          tooltips: {
            callbacks: {
              label(item, data) {
                const label = data.labels[item.index];
                const value = data.datasets[0].data[item.index];
                return `${label}: Bs ${self.formatTooltipMonto(value)}`;
              },
            },
          },
        },
      });
    },
    renderChartComposicion() {
      const ref = this.$refs.chartComposicion;
      if (!ref) return;
      this.destroyChart('composicion');
      const r = this.resumenGeneral;
      const self = this;
      this.chartInstances.composicion = new Chart(ref.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: ['Cobranza pagado', 'Cobranza pendiente', 'Marketing pagado', 'Marketing pendiente'],
          datasets: [{
            data: [
              r.pagado_cobranza,
              Math.max(r.asignacion_mes_cobranza - r.pagado_cobranza, 0),
              r.pagado_marketing,
              Math.max(r.asignacion_mes_marketing - r.pagado_marketing, 0),
            ],
            backgroundColor: ['#c62828', '#ef9a9a', '#2e7d32', '#a5d6a7'],
            borderWidth: 0,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { boxWidth: 10, fontSize: 10 } },
          tooltips: {
            callbacks: {
              label(item, data) {
                const label = data.labels[item.index];
                const value = data.datasets[0].data[item.index];
                return `${label}: Bs ${self.formatTooltipMonto(value)}`;
              },
            },
          },
        },
      });
    },
    renderChartEstado() {
      const ref = this.$refs.chartEstado;
      if (!ref) return;
      this.destroyChart('estado');
      const conteos = this.estadisticasPorEstado;
      const labels = Object.keys(conteos);
      const data = Object.values(conteos);
      const paleta = ['#43a047', '#fb8c00', '#e53935', '#1e88e5', '#8e24aa', '#00acc1'];
      this.chartInstances.estado = new Chart(ref.getContext('2d'), {
        type: 'pie',
        data: {
          labels,
          datasets: [{ data, backgroundColor: paleta.slice(0, labels.length), borderWidth: 0 }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { boxWidth: 10, fontSize: 10 } },
        },
      });
    },
    getIniciales(nombre) {
      if (!nombre || nombre === 'Sin Asignar') return 'S/A';
      return nombre.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    },
    exportarExcel() {
      if (!this.resumenPorEncargado.length) return;

      const headers = ['Encargado de Cobranza', 'Registros', 'Asignaci\u00f3n', 'Revertido', 'Descuento', 'Cambiado', 'Pagado', 'Saldo', 'Adelantado', '% Cobranza'];
      const rows = this.resumenPorEncargado.map(item => [
        `"${item.encargado}"`,
        item.cantidad_registros,
        item.asignacion.toFixed(2),
        item.monto_revertido.toFixed(2),
        item.monto_descuento.toFixed(2),
        item.cambiado.toFixed(2),
        item.monto_pagado.toFixed(2),
        item.saldo.toFixed(2),
        item.monto_adelantado.toFixed(2),
        item.porcentaje,
      ]);

      const csvContent = [headers.join(';')].concat(rows.map(e => e.join(';'))).join('\n');
      const blob = new Blob(["\ufeff", csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'Resumen_Cobranza_V8.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  created() {
    this.setSedePorDefecto();
  },
  watch: {
    '$store.state.CARGO.sede': function () {
      this.setSedePorDefecto();
    },
    datosFiltrados() {
      if (this.mostrarGraficos) this.$nextTick(() => this.renderGraficos());
    },
    mostrarGraficos(val) {
      if (val) this.$nextTick(() => this.renderGraficos());
      else this.destroyAllCharts();
    },
  },
  mounted() {
    // Opcional: Ejecutar consulta automáticamente al montar el componente
    // this.fetchData();
  },
  beforeDestroy() {
    this.destroyAllCharts();
  },
};
</script>

<style scoped>
.chart-wrapper {
  position: relative;
  height: 240px;
}
.chart-center-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}
</style>